import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutomatizePeriodService {
  private http = inject(HttpClient);
  private url = Global.url + 'V1/automatize-period';

  get(): Observable<any> {
    return this.http.get<any>(this.url);
  }

  update(data: any): Observable<any> {
    return this.http.put<any>(this.url, data);
  }

  run(): Observable<any> {
    return this.http.post<any>(`${this.url}/run`, {});
  }
}
